/**
 * One helper for the per-ask events so `ask`, `completed_count` and `total` reach every call site. A
 * discriminator missing from one path is invisible in Amplitude: that path just drops out of any segment
 * built on it.
 */
import type { SetupExperimentArm, SetupStepId } from "~vue/ProfileSetup/types";
import type AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";

export interface AskProgress {
    completedCount: number;
    total: number;
    /** 1-based place of the ask in the order this user was shown. */
    stepPosition: number;
    experimentArm: SetupExperimentArm | null;
}

export function logAskEvent(event: AmplitudeEventNames, ask: SetupStepId, { completedCount, total, stepPosition, experimentArm }: AskProgress): void {
    void logUserInteraction(event, {
        ask,
        completed_count: completedCount,
        total,
        step_position: stepPosition,
        ...(experimentArm === null ? {} : { experiment_arm: experimentArm }),
    });
}
